import { render, staticRenderFns } from "./FactorBandEdit.vue?vue&type=template&id=b6b5e3e2&scoped=true"
import script from "./FactorBandEdit.vue?vue&type=script&lang=js"
export * from "./FactorBandEdit.vue?vue&type=script&lang=js"
import style0 from "./FactorBandEdit.vue?vue&type=style&index=0&id=b6b5e3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b5e3e2",
  null
  
)

export default component.exports